import { useEffect, useRef } from "react";

export default function HeroSection() {
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;
    el.style.opacity = "0";
    el.style.transform = "translateY(40px)";
    setTimeout(() => {
      el.style.transition = "opacity 1.2s ease, transform 1.2s ease";
      el.style.opacity = "1";
      el.style.transform = "translateY(0)";
    }, 200);
  }, []);

  const scrollDown = () => {
    const about = document.querySelector("#about");
    if (about) about.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen w-full overflow-hidden bg-[#0D0D0D]"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/79bbd12133c9c5c423ad9964f66c8be6/4422d5872b0b8e43a8eded237c3d16c3.png"
          alt="OFF-PATTERN Hero"
          className="w-full h-full object-contain opacity-40"
          style={{ objectPosition: "center center" }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0D0D0D]/80 via-[#0D0D0D]/50 to-[#1D3557]/40" />
      </div>

      {/* Date Badge */}
      <div className="absolute top-20 right-8 md:right-16 z-10">
        <div className="bg-[#E63946] px-4 py-2 rounded-full">
          <p className="font-mono text-[10px] uppercase tracking-[3px] text-white whitespace-nowrap">
            26 MARCH 2026 / TOWN HOUSE
          </p>
        </div>
      </div>

      {/* KAPDAA Badge */}
      <div className="absolute top-20 left-8 md:left-16 z-10 hidden md:block">
        <div className="border border-white/30 px-4 py-2 rounded-full">
          <p className="font-mono text-[10px] uppercase tracking-[3px] text-white/70 whitespace-nowrap">
            IN COLLABORATION WITH KAPDAA
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div ref={textRef} className="relative z-10 w-full min-h-screen flex flex-col justify-end pb-20 px-8 md:px-16">
        <div className="max-w-5xl">
          {/* Exhibition Label */}
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-[2px] bg-[#E63946]" />
            <span className="font-mono text-[11px] uppercase tracking-[4px] text-[#E63946]">
              Exhibition 2026
            </span>
          </div>

          {/* Giant Title */}
          <h1 className="font-display leading-none mb-2" style={{ fontSize: "clamp(80px, 14vw, 180px)" }}>
            <span className="text-[#E63946]">OFF-</span>
            <span className="text-white">PATTERN</span>
          </h1>
          <div className="flex items-baseline gap-4 mb-8">
            <h2 className="font-display text-white leading-none" style={{ fontSize: "clamp(28px, 5vw, 64px)" }}>
              Beyond the Standard
            </h2>
            <div className="hidden md:block w-24 h-[2px] bg-[#1D3557] mb-2" />
          </div>

          {/* Subtext Row */}
          <div className="flex flex-col md:flex-row md:items-end gap-6 md:gap-16">
            <p className="font-body text-white/60 text-base md:text-lg max-w-md leading-relaxed">
              Where textile waste becomes wonder. Exploring human imperfection through ugly-cute character-based bag charms crafted from discarded garment materials.
            </p>

            {/* Scroll CTA */}
            <button
              onClick={scrollDown}
              className="flex items-center gap-4 cursor-pointer group"
            >
              <div className="w-14 h-14 rounded-full border-2 border-white/40 flex items-center justify-center group-hover:border-[#E63946] group-hover:bg-[#E63946]/10 transition-all duration-300">
                <i className="ri-arrow-down-line text-white text-xl" />
              </div>
              <span className="font-mono text-[10px] uppercase tracking-[3px] text-white/50 group-hover:text-white/80 transition-colors whitespace-nowrap">
                Scroll to Explore
              </span>
            </button>
          </div>
        </div>

        {/* Bottom Right Detail */}
        <div className="absolute bottom-20 right-8 md:right-16 text-right hidden md:block">
          <p className="font-mono text-[10px] text-white/30 uppercase tracking-[2px]">Town House</p>
          <p className="font-mono text-[10px] text-white/30 uppercase tracking-[2px]">Kingston University</p>
          <p className="font-mono text-[10px] text-white/30 uppercase tracking-[2px] mt-1">London, UK</p>
        </div>
      </div>

      {/* Bottom Red Strip */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#E63946]" />
    </section>
  );
}
